import Map from '../Map/Map';
import MapGradient from '../MapGradient/MapGradient.jsx';
import MapNavControls from '../MapNavControls/MapNavControls.jsx';
import CHHexagons from '../Layers/CenterHomeLayers/CHHexagons.jsx';
import CHPoints from '../Layers/CenterHomeLayers/CHPoints.jsx';
import CenterHomeLayerDropdown from '../CenterHomeLayerDropdown/CenterHomeLayerDropdown.jsx';

function MapBlock() {
  const widgets = (
    <>
      <CHHexagons />
      <CHPoints />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          position: 'absolute',
          top: '50%',
          left: '20px',
          transform: 'translateY(-50%)',
          rowGap: '20px',
        }}
      >
        <MapNavControls />
      </div>
      <MapGradient />
      <CenterHomeLayerDropdown />
    </>
  );

  return (
    <>
      <Map />
      {widgets}
    </>
  );
}

export default MapBlock;
